import { computed, ref, watch, } from 'vue'
import { debounce, } from '@/assets/js/src/util/uiTools'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useResourceListStore, } from '@/assets/js/src/modules/resource/_pinia/resourceList'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'
import { ERROR, LOADED, LOADING, UPDATING, } from '@/assets/js/src/util/composables/usePrefetchData'
import { DIR_LTR, DIR_RTL, } from '@/assets/js/src/modules/lang/_pinia/lang'

export function useDictionaryListFilter () {
    let resourceListStore = useResourceListStore(getActivePinia())

    const { search, } = storeToRefs(resourceListStore)

    // FILTER
    const abbreviations = computed(mapUserOptionByPath('resource/dictionary/abbreviations'))
    watch(abbreviations,()=>resourceListStore.reload = true)
    
    const debouncedSearch = ref(search.value)
    watch(debouncedSearch,
        debounce((newVal) => search.value = newVal, 300),
        { immediate: !import.meta.env.SSR, })
    watch(search,()=>resourceListStore.reload = true)
    
    return {
        debouncedSearch,
        abbreviations,
        LOADED,
        LOADING,
        UPDATING,
        ERROR,
        DIR_RTL,
        DIR_LTR,
    }
}
